import { NFLookupCatalog } from "./NFLookupCatalog";
import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";

interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupPosition = ({
  title,
  fieldName,
  required,
  showBorder,
  selectedCatalog,
  setSelectedCatalog,
}: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.Position.getDataService().GetAll(searchText);
  };

  return (
    <>
      <NFLookupCatalog
        fieldName={fieldName}
        title={title}
        entity={AppEntities.Position}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        <NFLookupCatalogColumn fieldName={"id"} caption={"Id"} />
        <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} />
      </NFLookupCatalog>
    </>
  );
};
